import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const Container = styled.div`
    width: 100%;

    border-radius: 6px;
    background: ${carbon[0]};
`;

export const TopContainer = styled(Flex)`
    align-items: center;
    padding: 16px;

    border-bottom: 1px solid ${carbon[50]};
`;

export const BottomContainer = styled(Stack)`
    padding: 16px;
    gap: 8px;

    overflow: hidden;

    .carouselNavBtn {
        opacity: 0;

        transition: opacity 150ms ease-in-out;
    }

    &:hover {
        .carouselNavBtn {
            opacity: 1;
        }
    }
`;

export const CreateBtnContainer = styled.div`
    margin-left: auto;
`;
